import { createSelector } from 'reselect';

const selectPayrolls = (state: any) => state.payrolls;


export const selectCurrentItem = createSelector([selectPayrolls], (payrolls) => payrolls.current);

export const selectListItems = createSelector([selectPayrolls], (payrolls) => payrolls.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectPayrolls], (payrolls) => payrolls.create);

export const selectUpdatedItem = createSelector([selectPayrolls], (payrolls) => payrolls.update);

export const selectReadItem = createSelector([selectPayrolls], (payrolls) => payrolls.read);

export const selectDeletedItem = createSelector([selectPayrolls], (payrolls) => payrolls.delete);

export const selectSearchedItems = createSelector([selectPayrolls], (payrolls) => payrolls.search);

export const selectItemsCount = createSelector([selectPayrolls], (payrolls) => payrolls.count);

export const selectItemsFilter = createSelector([selectPayrolls], (payrolls) => payrolls.filter);